import { render, staticRenderFns } from "./Blogr.vue?vue&type=template&id=5e627e66&"
import script from "./Blogr.vue?vue&type=script&lang=js&"
export * from "./Blogr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports